import React, {useEffect, useRef, useState} from 'react';
import {
    AppBar,
    Box,
    Button,
    Toolbar,
    Grid,
    Typography,
    Avatar,
    IconButton,
    Switch,
    ListItem,
    ListItemText, CircularProgress
} from "@mui/material";
import {Add, Delete, Security} from "@mui/icons-material";
import HeaderAvatar from "../components/HeaderAvatar";
// import {usePermissions} from "../components/PermissionsContext";
// import { fetchCompanyMembers} from "../services/api";
import {floor} from "lodash";
import {Link, useNavigate} from 'react-router-dom';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';

// interface Statistics {
//     "total_projects": number;
//     "self_projects": number;
//     "total_telecasts": number;
//     "total_categories": number;
//     "total_tvprograms": number;
//     "total_tariffs": number;
//     "tvprogram_duration": number;
//     "team_members": number;
//     "playlist_downloads": number;
//     "unique_playlist_downloads": number;
// }

interface TeamMember {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    image_url: string;
    is_active: boolean;
}

// interface GData {
//     hour: string;
//     всего: number;
//     уникальных: number;
// }

interface StatisticsDownloads {
    period: string;
    total_downloads: number[];
    unique_downloads: number[];
}


const Home: React.FC = () => {
    // const {permissions} = usePermissions();

    return (

        <Box>
            <AppBar position="static">
                <Toolbar className='toolbar'>
                    <Box className='toolbarTitle'>Главная</Box>
                    <HeaderAvatar/>
                </Toolbar>
            </AppBar>

        </Box>
    );

};

export default Home;
